import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import type {
  GlobalDialogStoreProps,
  GlobalDialogStoreState,
} from './types/use-global-dialog-store-types';

const initialState: GlobalDialogStoreState = {
  isOpen: false,
  title: null,
  description: null,
  actionText: 'OK',
  onAction: undefined,
};

export const useGlobalDialogStore = create<GlobalDialogStoreProps>()(
  devtools(
    (set) => ({
      ...initialState,

      showDialog: ({ title, description, actionText = 'OK', onAction }) => {
        set(
          () => ({
            isOpen: true,
            title,
            description,
            actionText,
            onAction,
          }),
          false,
          'SHOW_GLOBAL_DIALOG'
        );
      },

      closeDialog: () => {
        set(() => ({ ...initialState }), false, 'CLOSE_GLOBAL_DIALOG');
      },
    }),
    { name: '@upstack/global-dialog', enabled: process.env.NODE_ENV === 'development' }
  )
);
